module.exports = __webpack_public_path__ + "media/images/logo_sp-b04e7e24f5e864818734953287d0b78e.svg";